import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var ArrayNavigator = /*#__PURE__*/function () {
  function ArrayNavigator(items) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : items.length;
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : start - 1;

    _classCallCheck(this, ArrayNavigator);

    this.items = items;
    this.start = start;
    this.end = end;
    this.index = index;
  }

  _createClass(ArrayNavigator, [{
    key: "current",
    value: function current() {
      if (this.index === this.start - 1 || this.index === this.end) {
        return null;
      }

      return this.items[this.index];
    }
  }, {
    key: "next",
    value: function next() {
      this.index = Math.min(this.index + 1, this.end);
      return this.current();
    }
  }, {
    key: "previous",
    value: function previous() {
      this.index = Math.max(this.index - 1, this.start - 1);
      return this.current();
    }
  }, {
    key: "first",
    value: function first() {
      this.index = this.start;
      return this.current();
    }
  }, {
    key: "last",
    value: function last() {
      this.index = this.end - 1;
      return this.current();
    }
  }]);

  return ArrayNavigator;
}();